import React, { useState, useEffect } from "react";
import {
  Truck,
  Package,
  ShieldCheck,
  ChevronRight,
} from "lucide-react";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../../utils/firebase";
import { useNavigate } from "react-router-dom";



const benefits = [
  {
    icon: Truck,
    title: "Fast Kerala Delivery",
    desc: "Reliable logistics network for hotels, bakeries, cafés, and restaurant chains across Kerala.",
  },
  {
    icon: Package,
    title: "Custom Packaging",
    desc: "Tailored branding and packaging solutions for modern hospitality businesses.",
  },
  {
    icon: ShieldCheck,
    title: "Food Safety First",
    desc: "Premium food-grade materials and hygiene-focused procurement systems.",
  },
];

const Departments = () => {
  const [departments, setDepartments] = useState([]);
  const navigate = useNavigate()
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const sectionsRef = collection(db, "sections");
        const q = query(sectionsRef, orderBy("order"), limit(5));
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          const fetched = snapshot.docs.map(doc => {
            const data = doc.data();
            const image = data.image || "https://images.unsplash.com/photo-1542838132-92c53300491e?q=80&w=400";
            
            let desc = data.desc || data.description;
            if (!desc && data.categories) {
              desc = data.categories.map(c => c.title).join(", ");
            }
            if (!desc) {
              desc = "Explore our premium wholesale options";
            }
            return {
              id: doc.id,
              name: data.name || "",
              image,
              desc,
              ...data
            };
          });
          setDepartments(fetched);
        } else {
          setDepartments([]);
        }
      } catch (error) {
        console.error("Error fetching departments from sections collection:", error);
        setDepartments([]);
      }
    };
    fetchDepartments();
  }, []);
const handleCardClick = (section) =>{
  navigate(`/products?sectionId=${section.id}&sectionName=${encodeURIComponent(section.name)}`)
}
  return (
    <div className="bg-white">

      {/* ================= DEPARTMENTS ================= */}

      <section className="py-24 bg-[#FAF8F4] border-y border-[#ECE5D9]">

        <div className="max-w-[1700px] mx-auto px-6 lg:px-12">

          {/* SECTION HEADER */}

          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">

            <div>

              <span className="text-[#C86A4B] uppercase tracking-[0.3em] text-xs font-bold">

                Hospitality Categories

              </span>

              <h2 className="text-4xl md:text-5xl font-black text-[#2C3E2B] mt-4 leading-tight">

                Shop by Departments

              </h2>

              <p className="text-[#666] mt-5 max-w-2xl leading-8 text-lg">

                Explore our premium hospitality procurement categories
                tailored for restaurants, hotels, bakeries, cafés,
                and institutional kitchens.

              </p>

            </div>

          </div>

          {/* DEPARTMENT GRID */}

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 ">

            {departments.map((item, i) => (

              <div
                onClick={() => handleCardClick(item)}
                key={i}
                className="group bg-white rounded-[24px] overflow-hidden border border-[#ECE5D9] hover:shadow-xl hover:-translate-y-1 transition-all duration-500 cursor-pointer"
              >

                {/* IMAGE */}

                <div className="relative overflow-hidden h-48">

                  <img
                    src={item.img_url}
                    alt={item.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/5 to-transparent"></div>

                </div>

                {/* CONTENT */}

                <div className="p-5">

                  <div className="inline-flex px-3 py-1.5 rounded-full bg-[#F8F5EE] text-[#C86A4B] text-[10px] font-bold uppercase tracking-wide mb-3">

                    Wholesale Supply

                  </div>

                  <h3 className="text-xl font-extrabold text-[#2C3E2B] leading-tight">

                    {item.name}

                  </h3>

                  <p className="text-[#666] mt-2 leading-relaxed text-xs">

                    {item.desc}

                  </p>

                  <button className="mt-4 flex items-center gap-2 text-[#C86A4B] font-bold text-xs group-hover:gap-3 transition-all">

                    Explore Department

                    <ChevronRight className="w-3.5 h-3.5" />

                  </button>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ================= BENEFITS ================= */}

      <section className="py-24 bg-white">

        <div className="max-w-[1700px] mx-auto px-6 lg:px-12">

          {/* HEADER */}

          <div className="text-center max-w-3xl mx-auto mb-16">

            <span className="text-[#C86A4B] uppercase tracking-[0.3em] text-xs font-bold">

              Why CHEFCO

            </span>

            <h2 className="text-4xl md:text-5xl font-black text-[#2C3E2B] mt-5 leading-tight">

              Built For Modern Hospitality Businesses

            </h2>

            <p className="text-[#666] mt-6 leading-8 text-lg">

              Streamlining hospitality procurement with premium sourcing,
              efficient distribution, and reliable packaging solutions.

            </p>

          </div>

          {/* BENEFITS GRID */}

          <div className="grid md:grid-cols-3 gap-8">
            {benefits.map((item, index) => (

              <div
                key={index}
                className="group bg-[#FAF8F4] rounded-[36px] border border-[#ECE5D9] p-10 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 relative overflow-hidden"
              >

                {/* BG EFFECT */}

                <div className="absolute top-0 right-0 w-40 h-40 bg-[#C86A4B]/5 rounded-full blur-3xl"></div>

                {/* ICON */}

                <div className="relative z-10 w-16 h-16 rounded-2xl bg-white border border-[#ECE5D9] flex items-center justify-center text-[#C86A4B] shadow-sm">

                  <item.icon className="w-8 h-8" />

                </div>

                {/* CONTENT */}

                <div className="relative z-10">

                  <h3 className="text-2xl font-black text-[#2C3E2B] mt-8 leading-tight">

                    {item.title}

                  </h3>

                  <p className="text-[#666] mt-5 leading-8">

                    {item.desc}

                  </p>

                </div>

              </div>

            ))}
          </div>

        </div>

      </section>

    </div>
  );
};

export default Departments;